import React, { useEffect, useState } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { FileNode } from "gatsby-plugin-image/dist/src/components/hooks"
import classNames from "classnames"
import * as styles from "./PreviewBlog.module.css"

type BlogData = {
  image: string
  title: string
  date: string
  summary: string
  link: string
}

type PreviewBlogProps = {
  to?: string
  customize?: BlogData
}

const PreviewBlog = ({ to, customize }: PreviewBlogProps) => {
  const [blogData, setBlogData] = useState<BlogData>({
    image: "",
    title: "",
    date: "",
    summary: "",
    link: "",
  })

  const graphqlData = useStaticQuery<BlogGraphqlType>(BlogsGraphql)

  useEffect(() => {
    if (to) {
      const slug = to.split("/")[3]
      const blogDetails = graphqlData.allBlogJson.nodes.find(
        node => slug === node.slug
      )!
      const { title, date, summary } = blogDetails.content.childMdx.frontmatter
      const image =
        blogDetails.image.childImageSharp?.gatsbyImageData.images.fallback?.src!
      const link = to

      setBlogData({ title, date, summary, image, link })
    } else if (customize) {
      setBlogData(customize)
    }
  }, [to, customize, graphqlData])

  const { image, title, date, summary, link } = blogData

  return (
    <Link to={link}>
      <div className={classNames(styles.list)}>
        <img src={image} />
        <div className={styles.content}>
          <h3>{title}</h3>
          <span>{date}</span>
          <p>{summary.slice(0, 230)}...</p>
        </div>
      </div>
    </Link>
  )
}

type BlogGraphqlType = {
  allBlogJson: {
    nodes: Array<{
      slug: string
      image: FileNode
      content: {
        childMdx: {
          frontmatter: {
            industries: string[]
            categories: string[]
            summary: string
            title: string
            date: string
            author: string
            time: number
            keywords: string[]
          }
        }
      }
    }>
  }
}

const BlogsGraphql = graphql`
  query AllBlog {
    allBlogJson {
      nodes {
        slug
        image {
          childImageSharp {
            gatsbyImageData(formats: WEBP, placeholder: BLURRED)
          }
        }
        content {
          childMdx {
            frontmatter {
              industries
              categories
              summary
              keywords
              title
              author
              date
              time
            }
          }
        }
      }
    }
  }
`

export default PreviewBlog
